import React from "react";

interface PDFViewerProps {
  url: string;
  downloadName?: string;
  height?: string;
}

const PDFViewer: React.FC<PDFViewerProps> = ({
  url,
  downloadName = "documento.pdf",
  height = "500px",
}) => {
  return (
    <div className="flex flex-col items-center gap-4">
      {/* Visualización del PDF */}
      <iframe
        src={url}
        title="PDF Viewer"
        width="100%"
        height={height}
        className="border border-zinc-600 rounded shadow max-w-5xl"
      />

      {/* Botón para descargar */}
      {/* <a
        href={url}
        download={downloadName}
        target="_blank"
        rel="noopener noreferrer"
        className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 mb-2"
      >
        Descargar PDF
      </a> */}
    </div>
  );
};

export default PDFViewer;
